export default "__VITE_ASSET__9Jpvn852__"